import { IAudit } from 'src/app/core/interfaces/audit.interface';
import { IDrawer } from 'src/app/core/interfaces/drawer.interface';
import { ITerminal } from 'src/app/core/interfaces/terminal.interface';
import { IWaiter } from 'src/app/core/interfaces/waiter.interface';
import { IFolder } from '../../../product-folder/interface/product-folder.interface';

export class Session {
  constructor(
    readonly drawer: IDrawer | null,
    readonly audit: IAudit | null,
    readonly folder: IFolder | null,
    readonly location: Location | null,
    readonly terminal: ITerminal | null,
    readonly waiter: IWaiter | null
  ) {}
}
